/** Defaults merged into useGet when the URL resource has `sideEffectGet: true`. Caller `queryConfig` is spread after and overrides. */
export const SIDE_EFFECT_GET_QUERY_DEFAULTS = {
  gcTime: 0,
  staleTime: 0
} as const;

export function mergeSideEffectGetQueryConfig<C extends Record<string, unknown>>(
  sideEffectGet: true | undefined,
  queryConfig: C
): C & Partial<typeof SIDE_EFFECT_GET_QUERY_DEFAULTS> {
  if (!sideEffectGet) {
    return queryConfig;
  }
  return {
    ...SIDE_EFFECT_GET_QUERY_DEFAULTS,
    ...queryConfig
  };
}
